/* eslint-disable @typescript-eslint/no-empty-object-type */
import { ComponentPropsWithoutRef, FC } from "react";

import { cn } from "@/shared/lib/utils";

export interface AnimatedShinyTextProps extends ComponentPropsWithoutRef<"span"> {}

export const AnimatedShinyText: FC<AnimatedShinyTextProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <span className={cn("shimmer-wrapper", className)} {...props}>
      <span className="relative z-10">{children}</span>
      <span className="shimmer-overlay" />
    </span>
  );
};
